import { createStackNavigator } from "@react-navigation/stack";
import React from "react";

import type { SmokeScenario } from "../../lib/screenshotMode";
import { useLanguageStore } from "../features/quiz-core/languageStore";
import ResultsScreen from "../features/quiz-core/ResultsScreen";
import SinglePlayerResultsScreen from "../features/single-player/screens/SinglePlayerResultsScreen";
import SinglePlayerSubmittingScreen from "../features/single-player/screens/SinglePlayerSubmittingScreen";
import { t } from "../i18n/translations";
import IQESPrototypeScreen from "../shared/ui/IQESPrototypeScreen";
import QuizGameScreen from "../shared/ui/QuizGameScreen";
import UnifiedBookSelectionScreen from "../shared/ui/UnifiedBookSelectionScreen";
import UnifiedCategoryScreen from "../shared/ui/UnifiedCategoryScreen";
import UnifiedDifficultyScreen from "../shared/ui/UnifiedDifficultyScreen";
import UnifiedTestamentScreen from "../shared/ui/UnifiedTestamentScreen";

export type RootStackParamList = {
  Category: undefined;
  Difficulty: { categoryId: number };
  Testament: undefined;
  BookSelection: undefined;
  IQESPrototype: undefined;
  SinglePlayerGame: {
    categoryId: number;
    difficulty_id: number;
    smokeScenario?: SmokeScenario;
    reviewAnswers?: string[];
    reviewData?: {
      questions: QuizQuestion[];
      answers: string[];
    };
  };
  SinglePlayerSubmittingScreen: { resultsData: unknown };
  SinglePlayerResultsScreen: { resultsData: unknown };
  Results: {
    score: number;
    totalQuestions: number;
    timeTaken: number | null;
    categoryId: number;
    difficulty_id: number;
    reviewData?: {
      questions: QuizQuestion[];
      answers: string[];
    };
  };
};

const Stack = createStackNavigator<RootStackParamList>();

type QuizQuestion = {
  id: string | number;
  question: string;
  options: string[];
  correct_answer: string;
  explanation?: string;
};

const SingleplayerNavigator = () => {
  const { language } = useLanguageStore();

  return (
    <Stack.Navigator initialRouteName="Category" data-oid="5zq0kzh">
      <Stack.Screen
        name="Category"
        component={UnifiedCategoryScreen}
        options={{ headerShown: false, title: t("category", language) }}
        data-oid=".o94nb8"
      />

      <Stack.Screen
        name="Difficulty"
        component={UnifiedDifficultyScreen}
        options={{ headerShown: false }}
        data-oid="v2hy8v2"
      />

      <Stack.Screen
        name="Testament"
        component={UnifiedTestamentScreen}
        options={{
          headerShown: false
        }}
        data-oid="nngocj4"
      />

      <Stack.Screen
        name="BookSelection"
        component={UnifiedBookSelectionScreen}
        options={{
          headerShown: false
        }}
        data-oid="ft1459e"
      />

      <Stack.Screen
        name="IQESPrototype"
        component={IQESPrototypeScreen}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="SinglePlayerGame"
        component={QuizGameScreen}
        options={{ headerShown: false }}
        data-oid="147za_x"
      />

      <Stack.Screen
        name="SinglePlayerSubmittingScreen"
        component={SinglePlayerSubmittingScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name="SinglePlayerResultsScreen"
        component={SinglePlayerResultsScreen}
        options={{ headerShown: false }}
      />

      <Stack.Screen
        name="Results"
        component={ResultsScreen}
        options={{ headerShown: false }}
        data-oid="x65kg2l"
      />
    </Stack.Navigator>
  );
};

export default SingleplayerNavigator;
